/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type LimitMarginOrderBalanceQueryVariables = Types.Exact<{
	assetId: Types.Scalars["String"];
}>;

export type LimitMarginOrderBalanceQuery = {
	__typename?: "Query";
	limitMarginOrderBalance: {
		__typename?: "LimitMarginOrderBalanceResponse";
		takeProfitAvailableBalance: string;
		stopLossAvailableBalance: string;
	};
};

export const LimitMarginOrderBalanceDocument = gql`
	query limitMarginOrderBalance($assetId: String!) {
		limitMarginOrderBalance(assetId: $assetId) {
			takeProfitAvailableBalance
			stopLossAvailableBalance
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class LimitMarginOrderBalanceGQLService extends Apollo.Query<
	LimitMarginOrderBalanceQuery,
	LimitMarginOrderBalanceQueryVariables
> {
	document = LimitMarginOrderBalanceDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
